export function addToGroups(name, value, groups) {
    if (value.toLowerCase() === "y" && groups.indexOf(name) === -1) {
        groups.push(name);
    }
}
